import styled from 'styled-components';
import ImageTag from '../../../../common/atoms/DamImage/molecules/ImageTag.view';

// eslint-disable-next-line import/prefer-default-export
export const StyledPinchZoomImage = styled(ImageTag)`
  height: 60vh;
  width: 100%;
  object-fit: contain;
`;
